import { render, staticRenderFns } from "./ExerciseText.vue?vue&type=template&id=4d229ca3&scoped=true&"
import script from "./ExerciseText.vue?vue&type=script&lang=js&"
export * from "./ExerciseText.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseText.vue?vue&type=style&index=0&id=4d229ca3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d229ca3",
  null
  
)

export default component.exports